(ns app.front.view.admin.migration.migrate-property-units
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/migrate-property-units
    :title     "Migrate property units"
    :help-text (str "This migration finds properties with data source 'applicant' whose addresses contain "
                    "unit designators (Apt, Suite, Unit, Lot), parses the unit number, creates property unit "
                    "entities, and sets the properties as unverified. If a matching unit designator does not "
                    "exist for the domain group, one will be created automatically.")}
   match])

(def route
  {:name        :view/admin.migration.migrate-property-units
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/migrate-property-units]))}]})

(defn revert-view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/revert-migrate-property-units
    :title     "Revert property unit migration"
    :help-text (str "This task reverses every transaction created by 'Migrate property units', newest first. "
                    "Revert the workspace address unit migration before running this task. "
                    "Do not run either forward migration while this task is in progress.")}
   match])

(def revert-route
  {:name        :view/admin.migration.revert-migrate-property-units
   :view        revert-view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/revert-migrate-property-units]))}]})
